import React from 'react';
import PropertyList from '../features/Properties/components/PropertyList/PropertyList';

function Properties() {
    return (
        <>
            <PropertyList />
        </>
    );
}

export default Properties;
